import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Container,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { resendOtp, resetPassword } from "../../apis/apisList/userApi";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { toast } from "react-toastify";
const auth_box = {
  logRegBox: {
    // display: "flex",
    // padding: "60px 60px 30px 60px",
  },
  loginCol: {
    // width: "47%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  signupCol: {
    // width: "47%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  orDividertxt: {
    height: "80px",
    width: "100%",
    textAlign: "center",
    background: "#FFF",
    lineHeight: "1.4",
    padding: "5px",
    fontSize: "16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: "1",
    fontStyle: "italic",
  },
  captchaTxt: {
    fontSize: "14px",
    textAlign: "center",
    fontWeight: "500",
    letterSpacing: "0.3px",
    color: "#333333",
    marginBottom: "65px",
  },
  cantLogin: {
    fontSize: "16px",
    color: "#333333",
    fontWeight: "600",
    letterSpacing: "0px",
  },
};
const ResetPassword = () => {
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = useState({
    password: "",
    confirmPassword: "",
    otp: "",
  });
  const [successMessage, setSuccessMessage] = useState("");
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfPassword, setShowConfPassword] = useState(false);

  const validateForm = () => {
    const newErrors = {};

    if (!otp) {
      newErrors.otp = "OTP is required.";
    }
    if (!password) {
      newErrors.password = "Password is required.";
    } else if (password.length < 6) {
      newErrors.password = "Password must be at least 6 characters.";
    }

    if (!confirmPassword) {
      newErrors.confirmPassword = "Confirm password is required.";
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    try {
      await resetPassword({
        newPassword: password,
        otp: otp,
        email: localStorage.getItem("temp_user"),
      });
      setSuccessMessage(
        "Password successfully updated. Redirecting to login..."
      );
      setTimeout(() => navigate("/login"), 3000);
    } catch (error) {
      const message =
        error.response.data.message || "Something went wrong. Try again.";
      console.error("Error updating password:", error);
      setErrors({ otp: message });
    }
  };

  const handleResend = async () => {
    try {
      const email = localStorage.getItem("temp_user");
      const response = await resendOtp({ email, type: "reset" });
      toast.success("Verification OTP sent to your email");
    } catch (error) {
      const message =
        error.response.data.message ||
        "Something went wrong. Please try again.";
      console.error("Error during handleResend request:", error);
      // Handle network or server error
      setErrors({ otp: message });
    }
  };

  return (
    <Container maxWidth="xl">
      <Box className="dashboard_frame">
        <Box className="backBtnFrame">
          <Button
            className="backBtn"
            variant="contained"
            sx={{ marginBottom: 2 }}
            onClick={() => (window.location.href = "/")}
          >
            <ArrowBackIcon sx={{ marginRight: 1 }} />
            Back to Homepage
          </Button>
        </Box>

        <Box
          style={auth_box.logRegBox}
          sx={{
            display: { xs: "block", sm: "block", md: "flex" },
            padding: {
              xs: "30px 30px 30px 30px",
              sm: "30px 30px 30px 30px",
              md: "60px 60px 30px 60px",
            },
          }}
        >
          <Box
            style={auth_box.loginCol}
            sx={{ width: { xs: "100%", sm: "100%", md: "100%" } }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: "355px",
                margin: "0 auto",
                padding: "100px 15px",
              }}
            >
              <Typography
                variant="h6"
                align="center"
                sx={{ marginBottom: 4, paddingBottom: 2, borderBottom: 2 }}
              >
                Set New Password
              </Typography>

              <TextField
                label="OTP"
                variant="outlined"
                fullWidth
                value={otp}
                onChange={(e) => {
                  setOtp(e.target.value);
                  setErrors({ ...errors, otp: "" }); // Clear the error message
                }}
                error={!!errors.otp} // Display error state
                helperText={errors.otp} // Display error message
                sx={{
                  marginBottom: 3,
                  "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button":
                    {
                      display: "none",
                    },
                  "& input[type=number]": {
                    MozAppearance: "textfield", // Firefox
                  },
                }}
                type="number"
              />

              <TextField
                label="New Password"
                type={showPassword ? "text" : "password"}
                variant="outlined"
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                error={!!errors.password}
                helperText={errors.password}
                sx={{ marginBottom: 3 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? (
                          <VisibilityOffIcon />
                        ) : (
                          <VisibilityIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <TextField
                label="Confirm Password"
                type={showConfPassword ? "text" : "password"}
                variant="outlined"
                fullWidth
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                error={!!errors.confirmPassword}
                helperText={errors.confirmPassword}
                sx={{ marginBottom: 3 }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowConfPassword(!showConfPassword)}
                      >
                        {showConfPassword ? (
                          <VisibilityOffIcon />
                        ) : (
                          <VisibilityIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              {successMessage && (
                <Typography
                  variant="body1"
                  align="center"
                  sx={{ color: "green" }}
                >
                  {successMessage}
                </Typography>
              )}

              <Button
                variant="contained"
                fullWidth
                onClick={handleSubmit}
                sx={{ marginBottom: 2 }}
                style={{
                  backgroundColor: "#065F9C",
                  boxShadow: "none",
                  borderRadius: "10px",
                  padding: "12px 20px",
                  fontSize: "20px",
                  fontWeight: "500",
                  textTransform: "inherit",
                }}
              >
                Reset Password
              </Button>
              <Button
                fullWidth
                onClick={handleResend} // Redirect to the login page
                sx={{
                  marginTop: 2,
                  textTransform: "inherit",
                  color: "#065F9C",
                }}
              >
                Resend OTP
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default ResetPassword;
